/**
 * @generated SignedSource<<ff81ff103fc7db559713cfd49e1ee379>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SubscribeContactToListInput = {
  contactIdentifier: string;
  mailingListIdentifier: string;
};
export type SubscribeContactToListDialogMutation$variables = {
  input: SubscribeContactToListInput;
};
export type SubscribeContactToListDialogMutation$data = {
  readonly subscribeContactToList: {
    readonly id: string;
    readonly subscribedCount: number;
  };
};
export type SubscribeContactToListDialogMutation = {
  response: SubscribeContactToListDialogMutation$data;
  variables: SubscribeContactToListDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MailingList",
    "kind": "LinkedField",
    "name": "subscribeContactToList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subscribedCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscribeContactToListDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SubscribeContactToListDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0ffea31c37a60e5282d6affb0403f7c8",
    "id": null,
    "metadata": {},
    "name": "SubscribeContactToListDialogMutation",
    "operationKind": "mutation",
    "text": "mutation SubscribeContactToListDialogMutation(\n  $input: SubscribeContactToListInput!\n) {\n  subscribeContactToList(input: $input) {\n    id\n    subscribedCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "d2f711d7bd39488454183b18215f6523";

export default node;
